// Variables d'environnement frontend (build-time via Vite)
// Définies par GitLab CI Variables avec scope preprod/prod.

/**
 * URL du serveur OIDC (PréventionBTP).
 * - Preprod : `https://preprod-id.preventionbtp.fr`
 * - Prod : `https://id.preventionbtp.fr` (défaut si VITE_OIDC_ISSUER non défini)
 *
 * Utilisée notamment pour construire le lien "Ajouter une entreprise"
 * quand le compte SSO n'a aucune organisation rattachée (story 19).
 */
export const OIDC_ISSUER: string =
  (import.meta.env.VITE_OIDC_ISSUER as string | undefined) || 'https://id.preventionbtp.fr'
